export default angular.module('eventix.common.directives.focusInput', [])
    .directive('focusInput', ['$timeout', '$parse', function($timeout, $parse) {
        /**
         * @ngdoc directive
         * @name eventix.common.directives:focusInput
         * @restrict attribute
         * @description
         * Focus input field by watching attribute value
         * @example
         * ```
         * <input type="text" ng-model="vm.model.value" focusInput="vm.shouldBeFocused">
         * ```
         */
        return {
            restrict: 'A',
            link: function(scope, element, attributes) {
                let model = $parse(attributes.focusInput);

                scope.$watch(model, function(value) {
                    if (value === true)
                        $timeout(() => element[0].focus());
                });

                element.bind('blur', function() {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }]).name;
